@if (!AddressUtils.isAddressObjectEmpty(address)) {
  @if (!AddressUtils.isAddressEmpty(attentionTo)) {
    <p [attr.data-test]="'desc-attentionTo'">
      {{ attentionTo }}
    </p>
  }
  <p>
    @if (!address?.isCustom && !AddressUtils.isAddressEmpty(address?.sapId)) {
      <span [attr.data-test]="'desc-sapId'">
        {{ address.sapId }} -
      </span>
    }
    @if (!AddressUtils.isAddressEmpty(address?.company)) {
      <span [attr.data-test]="'desc-company'">
        {{ address.company }}
      </span>
    }
  </p>
  @if (!AddressUtils.isAddressEmpty(address?.address1)) {
    <p [attr.data-test]="'desc-address1'">
      {{ address.address1 }}
    </p>
  }
  <p [attr.data-test]="'desc-address2'">
    @if (!AddressUtils.isAddressEmpty(address?.zipCode)) {
      <span [attr.data-test]="'desc-address2-zipCode'">{{ address.zipCode }} </span>
    }
    @if (!AddressUtils.isAddressEmpty(address?.city)) {
      <span [attr.data-test]="'desc-address2-city'">{{ address.city }}</span>
    }
  </p>
  @if (!AddressUtils.isAddressEmpty(address?.state)) {
    <p [attr.data-test]="'desc-state'">
      {{ address.state }}
    </p>
  }
  @if (!AddressUtils.isAddressEmpty(AddressUtils.getCountryName(address?.country))) {
    <p [attr.data-test]="'desc-country'">
      {{ AddressUtils.getCountryName(address.country) }}
    </p>
  }
} @else {
  <span>-</span>
}
